<template>
  <div>
    <div class="ti d-flex">
      <div class="d-flex-left">
        <erp-tree @node-click="nodeClick"></erp-tree>
      </div>
      <div class="d-flex-right" style="margin-top: 10px;">
         <el-button @click="order_update" v-if="ERP.isPermission(4003007002)">费用收付</el-button>
         <!-- <el-button>预收款</el-button>
         <el-button>押金收取</el-button> -->
         <el-button @click="paid">已缴款</el-button>
         <el-button @click="order_invo_select">票据查询</el-button>
         <el-button @click="order_elctronic_invoice_select">电子发票</el-button>
         <el-button @click="order_invoice_mount">订单挂账</el-button>
         <!-- <el-button @click="order_invo">待开票查询</el-button> -->
         <!-- <el-button>临时缴款</el-button> -->
         <el-button @click="order_frozens" v-if="ERP.isPermission(4003007008)">冻结账单</el-button>
         <el-button @click="temporay" v-if="ERP.isPermission(4003008)">临时费用</el-button>
         <!-- <el-button @click="order_user_frozens" v-if="user_room == 2 && ERP.isPermission(40360004002)">同步业户</el-button> -->
         <!-- <el-button style="color: red;" @click="order_pull" v-if="user_room == 2 && ERP.isPermission(40360004002)">同步账单</el-button> -->
         <!--<el-button @click="user">业户调整</el-button>-->
         <!-- <router-link to="/order/order/orderAdjust">
           <el-button style="color: #606266;" >应收费用调整(流程)</el-button>
         </router-link> -->
         <el-button style="color: #606266;" @click="dialogVisible8=true">流程</el-button>
         <el-button @click="order_add()" v-if="ERP.isPermission(4003007014)">新增账单</el-button>
        <el-button @click="copyOrderDetailIds" >复制订单id</el-button>
         <!-- <el-button @click="order_add()">新增账单</el-button> -->
         <el-button @click="change(1)">查询</el-button>
        <div style="width: 99%;">
          <div>
            <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
              <el-descriptions-item label="查询房产/客户">
                <el-autocomplete
                  v-model="house_name"
                  size="mini"
                  style="width: 100%;"
                  :fetch-suggestions="querySearchAsync"
                  placeholder="可搜索房产/客户姓名"
                  clearable
                  @select="handleSelect"
                ></el-autocomplete>
              </el-descriptions-item>
              <el-descriptions-item label="票据打印">
                <RadioGroup v-model="select.money">
                    <Radio label="单价不一致合并"></Radio>
                    <Radio label="单价不一致不合并"></Radio>
                </RadioGroup>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item  label="客户名称">
              <div style="display: flex;">
                <div style="width: 70%;">
                  <el-select v-model="select.name"  @change="name_changes" size="mini" clearable placeholder="客户名称" style="width: 90%;">
<!--                      <el-option v-for="item in customer" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
                      <el-option
                        v-for="item in customer"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        <span style="float: left">{{ item.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.id==1 ? '' : item.id }}</span>
                      </el-option>
                  </el-select>
                  <span v-if="house_customer > 0" style="color: red;margin-left: 3px;width: 150px;">{{house_customer}}户</span>
                </div>
                <div style="width: 30%;" v-if="house_customer > 0">
                    <div @click="all" style="color: red;text-align: right;margin-top: 5px;cursor: pointer;margin-left: 1px;">查询全部房产费用</div>
                </div>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="房产信息">
              <el-select v-model="select.house" @change="house_changes" size="mini" placeholder="房产信息" style="width: 85%;">
                  <el-option v-for="item in house" :key="item.id" :label="item.house" :value="item.house"></el-option>
              </el-select>
              <span v-if="house.length>0" style="color: red;margin-left: 3px;">{{house.length}}条房产</span>
            </el-descriptions-item>
            <el-descriptions-item  label="缴费日期">
              <div v-if="ERP.isPermission(4003007011)">
                <el-date-picker v-model="select.date" type="datetime" size="mini" style="width: 100%;" placeholder="缴费日期"></el-date-picker>
              </div>
              <div v-else>
                <el-date-picker v-model="select.date" type="datetime" size="mini" style="width: 100%;" placeholder="缴费日期" :disabled="disableds"></el-date-picker>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="备注">
              <el-input size="mini" v-model="remerks" placeholder="备注"></el-input>
            </el-descriptions-item>
            <el-descriptions-item  label="结算方式">
              <RadioGroup v-model="select.pay">
                <div style="display: flex;flex-wrap: wrap;">
                  <div v-for="it in dataPay" :key="it.id">
                      <Radio :label="it.number" :disabled="pid != 123 && [5, 9, 26].includes(it.number)">{{it.name}}</Radio>
                  </div>
                </div>
              </RadioGroup>
            </el-descriptions-item>
            <el-descriptions-item label="汇总方式">
              <Space direction="vertical" size="large">
                <RadioGroup v-model="select.house_type" @on-change="house_type">
                    <Radio label="明细"></Radio>
                    <!-- <Radio label="客户名称"></Radio> -->
                    <!-- <Radio label="房产"></Radio> -->
                    <Radio label="收费周期"></Radio>
                    <!-- <Radio label="房产与收费周期"></Radio> -->
                </RadioGroup>
              </Space>
            </el-descriptions-item>
            <el-descriptions-item  label="计费周期">
              <el-date-picker v-model="select.startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-date-picker v-model="select.endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item  label="收费项目">
              <div>
                <el-select v-model="select.chargeitemID" multiple filterable collapse-tags style="width: 70%" placeholder="收费项目">
                  <el-option size="mini" v-for="item in chargeitem" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
                </el-select>
                <span style="cursor: pointer" @click="complete">全选</span>
                <span style="margin-left: 3px; cursor: pointer" @click="cancel">取消</span>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div style="margin-top: 10px;">
          <span>选中金额：<span style="color: red;">{{money_val}}</span>元</span>
          <span style="margin-left: 15px;">总应收金费：<span style="color: red;">{{money}}</span>元</span>
          <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
          <el-table ref="multipleTable" height="50vh" :data="tableData" border style="width: 99%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" > </el-table-column>
            <!-- show-overflow-tooltip -->
            <el-table-column v-if="ERP.isPermission(4003007005)" prop="h_name_date" label="房产" width="300"></el-table-column>
            <el-table-column v-else prop="h_name_date" label="房产" show-overflow-tooltip></el-table-column>
            <el-table-column  label="状态" width="100">
               <template slot-scope="scope">
                 <div v-if="scope.row.IsFrozen === 1" style="color: red;" @click="getOrderFlow(scope.row.id)">
                   <span v-if="scope.row.frozen_type == 4">待减免暂缓收</span>
                   <span v-else-if="scope.row.frozen_type == 2">银行托收冻结</span>
                   <span v-else-if="scope.row.frozen_type == 5">转账流水待确认</span>
                   <span v-else>订单冻结</span>
                 </div>
                 <div v-else-if="scope.row.IsFrozen === 0 && scope.row.froze_money > 0" style="color:red">减免申请中</div>
                 <div v-else>正常</div>
               </template>
             </el-table-column>
            <el-table-column prop="chargeItem_name" label="收费项目" width="150"></el-table-column>
            <el-table-column prop="xsc_Price" label="单价" width="80"></el-table-column>
            <el-table-column prop="xsc_Amount" label="用量/面积合计" width="100"></el-table-column>
            <el-table-column prop="charging" label="面积" width="80"></el-table-column>
            <el-table-column  label="计费周期" width="180">
              <template slot-scope="scope">
                {{scope.row.startDate}}-{{scope.row.endDate}}
              </template>
            </el-table-column>
            <el-table-column prop="endDate" label="应收日期" width="100"></el-table-column>
            <el-table-column prop="account_book" label="所属日期" width="100"></el-table-column>
            <el-table-column prop="month_end_date" label="月结日期" width="100"></el-table-column>
            <el-table-column prop="chargePay" label="本期应收(原应收)" width="80"></el-table-column>
            <el-table-column prop="discount" label="减免" width="109"></el-table-column>
            <el-table-column prop="adjust_pay" label="调整原应收" width="109"></el-table-column>
            <el-table-column prop="adjust" label="调减" width="109"></el-table-column>
            <el-table-column prop="charge_sum" label="本期应收欠费" width="109"></el-table-column>
            <el-table-column prop="delaySum" label="违约金欠费" width="100"></el-table-column>
            <el-table-column label="冻结中金额" width="100" prop="froze_money"></el-table-column>
            <el-table-column label="违约金减免" width="100">
              <template slot-scope="scope">
                <el-input size="mini" @change='delayDiscount(tableData[scope.$index],scope.$index)'  v-model="tableData[scope.$index].delayDiscount"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="实收金额" width="100">
              <template slot-scope="scope">
                <el-input  @change="inputs(scope.row.id,scope.$index)" size="mini"  v-model="tableData[scope.$index].charge_money"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 打印 -->
        <prints ref="ref"></prints>
        <!-- 票据查询 -->
        <InvoicingSelect ref="invo_select"></InvoicingSelect>
        <NewInvoicingSelect ref="NewInvoicingSelect"></NewInvoicingSelect>
        <FinanceBillDetailed ref="FinanceBillDetailed" />
        <!-- 待开票 -->
        <Invoicing ref="invo"></Invoicing>
        <!-- 已付款 -->
        <paids ref="paid"></paids>
        <!-- 冻结账单 -->
        <frozen ref="frozens"></frozen>
        <electronic-invoice ref="electronic_invoice"></electronic-invoice>
        <!-- 账单管理 -->
        <orderAdd ref="orderAdd"></orderAdd>
         <!-- 调整收费对象 -->
        <!-- <Users ref="users"></Users> -->
        <!-- 减免类型 -->
        <el-dialog
          :modal='false'
          v-loading="loading"
          title="减免"
          :visible.sync="dialogVisibles"
          width="500px"
          :before-close="handleClose">
          <div style="height: 230px;overflow-y: auto;">
            <div>选择减免类型</div>
            <Space direction="vertical" size="large">
              <RadioGroup v-model="discount_data.discount_type" style="display: flex;flex-wrap: wrap;">
                <div v-for="item in discount_type">
                  <Radio v-if="item.number != '-1'" style="margin-top: 8px;" :label="item.number">{{item.name}}</Radio>
                </div>
              </RadioGroup>
            </Space>
            <div style="margin-top: 15px;">填写减免金额</div>
            <el-input style="width: 100%;margin-top: 5px;" size="mini"  v-model="discount_data.charge_money"></el-input>
            <el-row style="margin-top: 50px;margin-left: 270px;">
              <el-button @click="tups">取消减免</el-button>
              <el-button @click="discount_post" type="primary" style="color: aliceblue;">确定减免</el-button>
            </el-row>
          </div>
        </el-dialog>

        <!-- 打印票据 -->
        <el-dialog
          top="38vh"
          title="提示"
          :visible.sync="dialogVisible6"
          width="400px"
          :before-close="handleClose">
          <div style="height: 80px;align-items: center;margin-left: 59px;color: #000000;">
            <el-button @click="dialogVisible6 = false">关闭</el-button>
            <!-- this.prinone = {'id':backdata.data.detail_id,'money':this.select.money,'pid':this.pid}; -->
            <el-button @click="prin(prinone.id,prinone.money,prinone.pid)">打印票据</el-button>
<!--            <el-button @click="electronInvoice">电子发票</el-button>-->
          </div>
        </el-dialog>

        <el-dialog
          top="20vh"
          title="电子发票"
          :visible.sync="dialogVisible7"
          width="500px"
          :before-close="handleClose">
          <div style="height: 200px;align-items: center;color: #000000;">
            <el-form label-position="top" label-width="80px">
              <el-form-item label="发票抬头">
                <el-input v-model='invoice.title'></el-input>
              </el-form-item>
              <el-form-item label="客户电话或者邮箱">
                <el-input v-model='invoice.phone'></el-input>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible7 = false">关闭</el-button>
              <el-button type="primary" style="color: #ffffff;" @click="electronInvoiceAdd">确定开票</el-button>
          </span>
        </el-dialog>

        <!--流程-->
        <el-dialog
          top="10vh"
          title="流程"
          :visible.sync="dialogVisible8"
          width="500px"
          :before-close="handleClose">
          <div style="height: 300px;align-items: center;margin-left: 10px;color: #000000;">
            <el-row>
              <router-link to="/order/order/orderAdjust">
                <el-button style="color: #606266;" @click="dialogVisible8=false">应收费用调整(流程)</el-button>
              </router-link>
              <!-- <router-link to="/order/order/orderDiscountFlow">
                <el-button style="color: #606266;" @click="dialogVisible8=false">应收款减免(流程)</el-button>
              </router-link> -->
              <!-- <router-link to="/order/order/orderPaymentFlow">
                <el-button style="color: #606266;" @click="dialogVisible8=false">批量缴款(流程)</el-button>
              </router-link> -->
              <router-link to="/order/order/orderPaymentFlow">
                <el-button style="color: #606266;" @click="dialogVisible8=false">系统欠费减免流程</el-button> <!--批量缴款/减免-->
              </router-link>
              <router-link to="/order/order/orderRedFlushFlow">
                <el-button style="color: #606266;" @click="dialogVisible8=false">账单红冲(流程)</el-button>
              </router-link>
            </el-row>
            <el-row style="margin-top:12px;">
              <router-link to="/order/order/orderPayType">
                <el-button style="color: #606266;" @click="dialogVisible8=false">调整房产缴费周期流程</el-button>
              </router-link>

<!--                <el-button style="color: #606266;" @click="gotoPartPay">项目部分缴款设置</el-button>-->
              <router-link to="/order/order/billRedFlushFlow">
                <el-button style="color: #606266;" @click="dialogVisible8=false">票据红冲(流程)</el-button>
              </router-link>
            </el-row>
          </div>
        </el-dialog>

        <el-dialog
          top="10vh"
          title="减免相关流程"
          :visible.sync="dialogVisible9"
          width="600px"
          :before-close="handleClose">
          <div class="content">
            <div class="body">
              <el-table :data="pageData.list" border style="width: 100%">
                <el-table-column prop="task_id" label="TASK_ID" width="100"></el-table-column>
<!--                <el-table-column prop="serial_number" label="流水号">
                  <template #default="scope">
                    <el-link type="primary" @click="skipFlow(scope.row.task_id)">{{ scope.row.serial_number }}</el-link>
                  </template>
                </el-table-column>-->
                <el-table-column prop="serial_number" label="流水号">
                  <template #default="scope">
                    <el-link type="primary" @click="openFlow(scope.row.task_id)">{{ scope.row.serial_number }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="status_name" label="流程状态" width="100"></el-table-column>
              </el-table>
              <div class="pagination-wrap">
                <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                               :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                               @current-change="pageChange"></el-pagination>
              </div>
            </div>
          </div>
          <ViewFlow ref="viewFlowRef" />
        </el-dialog>

        <invoice-form ref="invoiceFormRef" :order_type="'not_pay_order'"></invoice-form>

        <money-pay ref="moneyPayRef" :visible="money_pay.visible"
                   :pay_info="money_pay.info"
                   :pay_method="select.pay"
                   :pindex_id="pid"
                   @pay_finish="handlePayFinish"
                   @close="money_pay.visible = false;"></money-pay>

      </div>
    </div>
  </div>
</template>

<script>
import ViewFlow from "./../Common/ViewFlow";
import FinanceBillDetailed from "./order/FinanceBillDetailed";
import NewInvoicingSelect from "./order/NewInvoicingSelect";

  export default {
    name: 'OrderList3',
    provide(){
      return{
        __ORDER__:null
      }
    },
    data () {
      return {
        invoice:{
          'title':'',
          'orderDetailIds': [],
          'phone': "",
          'pid': ""
        },
        pageData:{
          id:0,
          pid:0,
          list:[],
          total:0,
          page:1,
          pageSize:10,
        },
        dialogVisible9:false,
        dialogVisible8:false,
        dialogVisibles:false,
        dialogVisible6:false,
        dialogVisible7:false,
        disableds:true,
        house_name:'',
        loading:false,
        selectList:[],
        select:{
          money:'单价不一致合并',
          house_type:'收费周期',
          pay:'1',
          house:'',
          name:'',
          date:'',
          startDate:'',
          endDate:'',
          chargeitemID:[],
          all:{
            type:1,
            house:'',
          }
        },
        pid:'',
        pid_house:"",
        remerks:'',
        dataPay:[],
        tableData: [],
        customer:[],
        house_customer:0,
        order: [],
        house:[],
        discount_type:[],
        user_type:1,
        money:0,
        money_val:0,
        chargeitem:[],
        loading_dade:1,
        user_room:1,
        discount_data:{
          'id':'',
          'discount_type':'',
          'charge_money':'',
          'data':{}
        },
        prinone:{},

        money_pay : {
          visible : false,
          info : {},
        },

        table_loading :false,
      }
    },
    //界面没出来前加载
    created() {
      var login = window.localStorage.getItem('login');
      if(login == "admin"){
        this.disableds = false;
      }
      //加载收款方式
      this.$myhttp.get('admin/OrderPayment/index',{
        'Content-Type': 'application/json'
        }).then(backdata=>{
            let dataPay = backdata.data.data;
            this.dataPay = dataPay;
            this.select.date = backdata.data.date;
            this.select.pay = dataPay[0]['number']
      });
      //减免类型
      this.$myhttp.get('admin/common/discount_type',{
        'Content-Type': 'application/json'
        }).then(backdata=>{
            this.discount_type = backdata.data.data;
      });
      //加载收费大类（费项）
      this.$myhttp.get("admin/common/getChargeitem", {
          "Content-Type": "application/json",
      }).then((backdata) => {
        this.chargeitem = backdata.data.data;
      });
    },
    // 加载数据
    mounted(){
      this.__ORDER__=this;
    },
    computed:{
      __TABLE_HEIGHT__(){
        return ERP.getStore().__TABLE_HEIGHT__
      }
    },
    //事件
    methods: {
      //收费对象调整
      user(){
        // this.$refs.users.getInvo(this.house);
        window.open("/#/order/Users?house="+this.select.house, '_blank');
      },
      //减免
      discount(row){
        this.$Message.error('该功能已停用,请走流程申请!');
        //console.log(row)
        /*this.discount_data={
          'id':row.id,
          'discount_type':'',
          'charge_money':'',
          'data':row
        }
        this.dialogVisibles = true;*/
      },
      tups(){
        this.dialogVisibles = false;
      },
      handleClose(done) {
        done();
      },
      //减免提交
      discount_post(){
        //console.log(this.discount_data);
        this.$confirm('确定要减免吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ERP.showLoading()
          this.$myhttp.post('admin/OrderList/discount_post',this.discount_data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              ERP.hideLoading()
              if(backdata.data.code == 201){
                this.$Message.error(backdata.data.message);
              }else{
                this.dialogVisibles = false;
                this.$Message.success(backdata.data.message);
                this.change(1);
              }
          },err=>{
            this.dialogVisibles = false;
            ERP.hideLoading()
            this.$Message.error('请求超时!');
          });
        })
      },
      //减免违约金操作
      delayDiscount(data,indexs){
        if(data.delayDiscount == ''){
          return false;
        }
        if(data.delayDiscount == 0){
          return false;
        }
        //console.log(data);
        this.$confirm('确定要减免违约金吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ERP.showLoading()
          this.$myhttp.post('admin/OrderList/delayDiscount',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              ERP.hideLoading()
              this.tableData[indexs].delayDiscount = 0;
              if(backdata.data.code == 201){
                this.$Message.error(backdata.data.message);
              }else{
                this.dialogVisibles = false;
                this.$Message.success(backdata.data.message);
                this.change(1);
              }
          },err=>{
            this.tableData[indexs].delayDiscount = 0;
            this.dialogVisibles = false;
            ERP.hideLoading()
            this.$Message.error('请求超时!');
          });
        })
      },
      //全选
      complete() {
        let data = this.chargeitem;
        let id = data
          .map((ret) => {
            return ret.id;
          })
          .join(",");
        let idarray = "[" + id + "]";
        this.select.chargeitemID = JSON.parse(idarray);
      },
      //取消
      cancel() {
        this.select.chargeitemID = [];
      },
      //点击已缴款
      paid(){
        if(this.pid == ''){
          this.$Message.error('点击左边树选择项目');
          return false;
        }
        this.$refs.paid.getInvo(this.select,this.house,this.dataPay,this.customer,this.pid);
      },
      //点击待开票查询
      order_invo(){
        this.$refs.invo.getInvo(this.select,this.house);
      },
      //点击票据查询
      order_invo_select(){
        if(this.pid == ''){
          this.$Message.error('点击左边树选择项目');
          return false;
        }
        this.$refs.invo_select.getInvo({project_id:this.pid,...this.select},this.house,this.pid);
      },
      //账单管理
      order_add(){
        if(this.pid == ''){
          this.$Message.error('点击左边树选择项目');
          return false;
        }
        this.$refs.orderAdd.getInvo({project_id:this.pid,...this.select},this.house,this.pid);
      },
      //点击电子发票
      order_elctronic_invoice_select(){
        if(this.pid == ''){
          this.$Message.error('点击左边树选择项目');
          return false;
        }
        this.$refs.electronic_invoice.getInvo(this.select,this.house,this.pid);
      },
      //冻结账单
      order_frozens(){
        if(this.pid == ''){
          this.$Message.error('点击左边树选择项目');
          return false;
        }
        this.$refs.frozens.getInvo(this.select,this.house,this.dataPay,this.customer,this.pid);
      },
      //费用收付
      order_update(){
        // 查找支付方式名称
        const payMethod = this.dataPay.find(item => item.number === this.select.pay);
        const payName = payMethod ? payMethod.name : '';

        this.money_pay.info = {
          pid : this.pid,
          'order': this.order,
          'remerks': this.remerks,
          'pay': this.select.pay,
          'pay_name': payName, // 添加支付方式名称
          'date': this.select.date,
          'house_type': this.select.house_type,
          'customer_id': this.select.name ,
          'is_chang_time': ERP.isPermission(4003007011) ? 1 : 0 ,
          pay_total : 0,
        };
        this.order.forEach(item => {
          this.money_pay.info.pay_total += item.charge_money;
        })

        this.money_pay.visible = true;
      },
      // 费用收付完成
      handlePayFinish(detailIds){
        this.money_pay.visible = false;
                this.dialogVisible6 = true;
        this.prinone = {'id':detailIds,'money':this.select.money,'pid':this.pid};
                this.change(1);
                this.remerks = '';
      },
      prin(id,money,pid){
        if(pid){
          this.$refs.ref.getPrints(id,money,pid);//调用子组件打印336470
        }else{
          this.$refs.ref.getPrints(id,money,this.pid);//调用子组件打印336470
        }
      },
      //电子发票
      electronInvoice(){
        this.dialogVisible7 = true;
      },
      electronInvoiceAdd(){
        if(this.invoice.title == ''){
          this.$Message.error('发票抬头不能为空');
          return false;
        }
        if(this.invoice.phone == ''){
          this.$Message.error('客户电话或者邮箱不能为空');
          return false;
        }
        this.invoice.pid = this.prinone.pid;
        this.invoice.orderDetailIds = this.prinone.id.split(',');
        ERP.showLoading()
        this.dialogVisible7 = false;
        this.dialogVisible6 = false;
        this.$myhttp.post('admin/Invoice/issueInvoice',this.invoice,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            if(backdata.data.code == 500){
              this.$confirm(''+backdata.data.msg, '提示', {
                confirmButtonText: '关闭',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => { })
            }else{
              this.$Message.success(backdata.data.msg);
              this.invoice = '';
              this.phone = '';
              this.$refs.electronic_invoice.getInvo(this.select,this.house,this.pid);
            }
        },err=>{
          ERP.hideLoading()
          this.$Message.error('请求超时!');
        });
      },
      //点击树
      nodeClick(data){
        this.select.all.type = 1;
        this.select.name = '';
        this.user_type = 1;
        this.user_room = 1;
        this.pid = data.tree[0].pindex_id;
        this.pid_house = data.tree[0].name;
        let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
        if(data.tree[data.tree.length-1].type==='room'){
          this.remerks = '';
          this.select.house=tree_str;
          this.change(1);
          this.user_room = 2;
        }
      },
      //搜索账单
      change(e){
        this.order = [];//清空选中的账单
        //ERP.showLoading()
        this.house_customer = 0;
        this.loading_dade = 2;
        this.house = [];
        this.select.customer = this.customer;
        this.table_loading = true;
        this.$myhttp.post('admin/OrderList/index',this.select,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            //ERP.hideLoading()
          this.table_loading = false;
            this.loading_dade = 1;
            let data = backdata.data;
            this.tableData = data.data;
            this.money = data.money;
            if(this.user_type == 1){
              this.customer = data.customer;
              this.select.name = data.customer[0].id;
            }
            this.select.date = data.date;
            this.house = data.house;
            if(this.customer.length > 0){
              this.house_customer = this.customer.length - 1;
            }
            this.pid=data.pid;
            this.$forceUpdate();
        },err=>{
            this.table_loding = false;
          this.loading_dade = 1;
          //ERP.hideLoading()
          this.$Message.error('请求异常!');
        });
      },
      //查询该客户所有费项
      all(){
        this.select.all.type = 2;
        this.select.all.house = this.house.map(req=>{return req.id}).join(',');
        this.change(1);
      },

      //搜索框选中房产
      changes(e){
        this.select.name = '';
        this.user_type = 1;
        this.select.house = e;
        this.change(1);
      },
      //选择客户
      name_changes(e){
        this.user_type = 2
        this.change(1);
      },
      //选择房产
      house_changes(e){
        this.select.all.type = 1;
        this.user_type = 2;
        this.change(1);
      },
      //勾选账单
      handleSelectionChange(val) {
        this.order = val;
        let money = 0;
        this.order.map(req=>{
            money = Number(money) + Number(req.charge_money);
        })
        this.money_val = money.toFixed(2);
      },
      //修改实收金额
      inputs(id,indexs){
        let _this = this;
        let money = 0;
        _this.order.map((req,index)=>{
          if(req.id != id){
            money =  Number(money) + Number(req.charge_money);
          }
          if(req.id == id){
            _this.order[index].charge_money = Number(_this.tableData[indexs].charge_money);
            money =  Number(money) + Number(_this.tableData[indexs].charge_money);
          }
        })
        this.money_val = money.toFixed(2);
      },
      //远程搜索方式
      querySearchAsync(query, cb) {
        if (query !== '') {
          this.loading_dade = 2;
          this.$myhttp.get('admin/common/house_name?house_name='+encodeURIComponent(query),{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
              this.loading_dade = 1;
              this.selectList = backdata.data.data;
              let value = [];
              this.selectList.map(req=>{
                value.push({'value':req.house})
              })
              cb(value)
          });
        }
      },
      //同步业户和冻结账单
      order_user_frozens(){
        this.$confirm('确定同步业户吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ERP.showLoading()
          this.$myhttp.post('xsc/OrderUser/order_user_frozens',this.select,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              ERP.hideLoading()
              this.$Message.success('同步成功');
              this.select.name = '';
              this.user_type = 1;
              this.change(1);
          },err=>{
            ERP.hideLoading()
            this.$Message.error('请求异常!');
          });
        },err=>{
          ERP.hideLoading()
          this.$Message.error('请求超时!');
        });
      },
      //同步账单
      order_pull(){
        this.$confirm('确定同步账单吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ERP.showLoading()
          this.$myhttp.post('xsc/OrderUser/order_pull',this.select,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              ERP.hideLoading()
              this.$Message.success('同步成功');
              this.select.name = '';
              this.user_type = 1;
              this.change(1);
          },err=>{
            ERP.hideLoading()
            this.$Message.error('请求异常!');
          });
        },err=>{
          ERP.hideLoading()
          this.$Message.error('请求超时!');
        });
      },
      //搜索选中
      handleSelect(item) {
        this.select.all.type = 1;
        this.select.name = '';
        this.user_type = 1;
        this.select.house = item.value;
        this.change(1);
        this.user_room = 2;
      },
      //跳转临时费用
      temporay(){
        this.select.customer = this.customer;
        //console.log(this.select)
        let data = "?house="+this.select.house+"&user_id="+this.select.name+"&pid="+this.pid+"&pid_house="+this.pid_house;
        window.open("/#/order/temporary"+data, '_blank');
      },
      getOrderFlow(id) {
        if (id) {
          this.pageData.id = id;
        }
        this.$myhttp.get("/admin/OrderList/order_flow?pid=" + this.pid + '&id=' + this.pageData.id + '&page=' + this.pageData.page + '&pageSize=' + this.pageData.pageSize, {
          "Content-Type": "application/json",
        }).then((backdata) => {
          if (backdata.data.code == 200) {
            this.pageData.list = backdata.data.data;
            this.pageData.total = backdata.data.total;
            // this.pageData.page = backdata.data.page;
            // this.pageData.pageSize = backdata.data.pageSize;
            this.dialogVisible9 = true;
          } else {
            this.$Message.error(backdata.data.message);
          }
        });
      },
      pageChange(e) {
        console.log('pageChange', e)
        this.pageData.page = e;
        this.getOrderFlow();
      },
      skipFlow(taskId) {
        window.open(
          "https://crm.gdzawy.com:9000/#/flow/FlowView?task_id=" + taskId,
          "_blank"
        );
      },
      openFlow(task_id) {
        const that = this;
        if (!task_id) {
          that.$message.error('没有审批流程')
          return;
        }
        that.$refs.viewFlowRef.show({task_id: task_id})
      },
      //点击汇总方式改变
      house_type(v){
        if(this.select.house){
          this.change(1);
        }
      },
      // 订单挂载开票
      order_invoice_mount(){
        if(this.order.length === 0){
          this.$Message.error('请选择开票订单');
          return ;
        }
        this.$refs.invoiceFormRef.openInvoiceForm(this.pid , this.order);
      },
      // 复制订单ids
      copyOrderDetailIds(){
        if (this.order.length === 0) {
          this.$message.error('请先选择要复制的订单');
          return;
        }

        // 提取选中订单的ID
        const orderIds = this.order.map(item => item.id).join(',');

        // 创建临时textarea元素用于复制
        const textarea = document.createElement('textarea');
        textarea.value = orderIds;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);

        // 选中并复制文本
        textarea.select();
        const successful = document.execCommand('copy');

        // 清理临时元素
        document.body.removeChild(textarea);

        // 显示操作结果
        if (successful) {
          this.$message.success(`已复制 ${this.order.length} 个订单ID到粘帖板`);
        } else {
          this.$message.error('复制失败');
        }
      },
      // 部分缴款
      gotoPartPay(){
        this.$myhttp.get('admin/PartPay/checkPermission',{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data.code == 200){
            this.$router.push({
              path: '/pindex/partPay',
            })
          }else{
            this.$Message.error(backdata.data.msg);
          }
        },err=>{
          this.$Message.error('请求超时!');
        });
      },
    },
    watch:{

    },
    components: {
      ViewFlow,
      NewInvoicingSelect,
      FinanceBillDetailed,
      "erp-tree": () => import('../Common/erp-tree.vue'),
      "prints": () => import('./order/prints.vue'),
      "Invoicing": () => import('./order/Invoicing.vue'),
      "InvoicingSelect": () => import('./order/InvoicingSelect.vue'),
      "paids": () => import('./order/paids.vue'),
      "frozen": () => import('./order/frozen.vue'),
      "ElectronicInvoice": () => import('./order/electronicInvoice.vue'),
      "orderAdd": () => import('./order/orderAdd.vue'),
      "invoiceForm" : () => import('./order/electronicInvoiceForm.vue'),
      "moneyPay" : () => import('./order/moneyPay.vue'),
    },

  }
</script>

<style>
  .d-flex {
    display: flex;
  }
  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
    width: 250px;

  }
  .d-flex-right {
    flex: 1;
    overflow-x:hidden;
  }
  .text2{
    color: rgb(250, 248, 248);
  }
</style>

<style lang="scss" scoped>
  .right-main {
    display: flex;
    // overflow: auto;//体内容的滚动条
    flex: 1;
    background: #fff;
  }
  .content{
    .header{

    }
    .header-where{
      margin-top: 5px;
    }
    .body{
      margin-top: 10px;

      .pagination-wrap{
        display: table;
        /* text-align: center; */
        margin: 20px auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/Order.vue